"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPersonalNutritionItemsHandler = addPersonalNutritionItemsHandler;
var AddPersonalNutritionItemsFailed = _interopRequireWildcard(require("@ori-events/add-personal-nutrition-items-failed"));
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _api = require("../api");
var _constants = require("../constants");
var _logger = require("../logger");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
async function addPersonalNutritionItemsHandler({
  detail: {
    items,
    placement,
    referer
  }
}, {
  client,
  sessionId,
  tenant
}) {
  if (referer === '/mypages/order/order-detail' && tenant !== 'es') {
    window.location.replace('/mypages/order/subscriptions');
    return false;
  }
  const globalShoppingPersonalNutritionComponentsDto = {
    collection: items
  };
  const headers = {
    [_fetching.TENANT_CONTEXT]: tenant,
    [_constants.REFERER]: String(referer),
    [_fetching.PLACEMENT]: placement
  };
  try {
    await (0, _globalApiClientReact.updateShoppingSessionPersonalNutrition)(client, sessionId, globalShoppingPersonalNutritionComponentsDto, headers);
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while adding personal nutrition items in addPersonalNutritionItems event'
    });
    const errorEvent = new CustomEvent(AddPersonalNutritionItemsFailed.Name, {
      detail: {
        isSuccess: false,
        localizedMessage: String(error),
        message: String(error)
      }
    });
    window.dispatchEvent(errorEvent);
    return false;
  }

  // STEP 2 - Update shopping context via Online endpoint
  const rawData = await (0, _api.fetchShoppingContextData)();
  if (AddPersonalNutritionItemsFailed.isAddPersonalNutritionItemsErrorResponse(rawData)) {
    const errorEvent = new CustomEvent(AddPersonalNutritionItemsFailed.Name, {
      detail: rawData
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  const data = {
    ...rawData,
    isPersonalNutritionAddedAsLast: true
  };
  return data;
}
